// NOTE: adjust this import to your actual shared API helper path if different.
// Expected helpers: postBiz(service, action, payload), rows(response), json(response)
import { postBiz, rows, json } from '../core/coreapi';
import { normalizePpmLine } from './ppmApi';

export const fetchOfficialPpmReport = (ppmId: number) =>
  json(postBiz({s: 'ppmreport', a: 'official', rid: ppmId }));

export const fetchOfficialPpmRows = async (ppmId: number) =>
  rows(await postBiz({s: 'ppmreport', a: 'rows', rid: ppmId })).map(normalizePpmLine);

export const fetchOfficialPpmSummary = async (ppmId: number) =>
  rows(await postBiz({s: 'ppmreport', a: 'summary', rid: ppmId }));
